module.exports = {"placeholder":"search box","searchAutocompleteTitle":"Search history:"}